export default __webpack_public_path__ + "static/media/featured_tour_08.085ee001.png";